export enum LegalEnum {
  SOLE_PROP = 'Eenmanszaak',
  GP = 'VOF',
  FOUNDATION = 'Stichting',
  BV = 'BV',
}



// WEBPACK FOOTER //
// ./src/app/main/content/enums/LegalEnum.ts